import { matchPath as routerMatchPath } from 'react-router-dom'
import { AppsRoutes } from '../getRoute'

export const matchPath = (route: AppsRoutes) =>
  routerMatchPath(route, location.pathname)
